__webpack_require__.p = "https://cdn.n-tv.de/sport/0.66.5/_next/";